class BeautopiaSubscriptionChoice extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready) return;

    this.dataset.ready = 'true';

    this.purchaseOptions = this.querySelectorAll('[data-purchase-option]');
    this.planInput = this.querySelector('[data-selling-plan-input]');
    this.planSelect = this.querySelector('[data-selling-plan-select]');

    this.purchaseOptions.forEach((option) => {
      option.addEventListener('change', () => {
        this.updateSellingPlan('purchase option changed');
      });
    });

    this.planSelect?.addEventListener('change', () => {
      this.updateSellingPlan('delivery frequency changed');
    });

    this.updateSellingPlan('widget loaded');
  }

  updateSellingPlan(changeSource) {
    const selected = this.querySelector(
      '[data-purchase-option]:checked'
    );

    if (!selected || !this.planInput) return;

    this.planInput.value =
      selected.value === 'subscription'
        ? this.planSelect?.value || ''
        : '';

    this.dispatchEvent(
      new CustomEvent('subscription-widget:change', {
        bubbles: true,
        detail: {
          purchaseType: selected.value,
          sellingPlanId: this.planInput.value,
        },
      })
    );

    if (changeSource) {
      document.getElementById('Selling_plann').setAttribute("value", this.planInput.value || '');
      console.log('[Beautopia subscription widget]', {
        change: changeSource,
        purchaseType: selected.value,
        sellingPlanId: this.planInput.value || null,
        deliveryFrequency:
          this.planSelect?.selectedOptions[0]?.text || null,
        variantId: this.dataset.variantId || null,
        variantPrice:
          this.querySelector('[data-variant-price]')
            ?.textContent.trim() ||
          this.dataset.variantPrice ||
          null,
        subscriptionPrice:
          this.querySelector('[data-subscription-price]')
            ?.textContent.trim() || null,
      });
    }
  }
}

if (!customElements.get('subscription-choice')) {
  customElements.define(
    'subscription-choice',
    BeautopiaSubscriptionChoice
  );
}